import angular from 'angular';
import component from './HeaderNew.component';

const HeaderNew = angular
  .module('HeaderNew', [])
  .filter('toSnakecase', () => (str) => str.replace(/\s/g, '-'))
  .component('headerNew', component);

export default HeaderNew;
